"use client";
import React, { useRef, useState, useEffect } from "react";
import Image from "next/image";

const ImageCarousel = ({ additional_images }) => {
  const carouselRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);

  useEffect(() => {
    const checkOverflow = () => {
      if (additional_images?.length > 4) {
        setHasOverflow(true);
      }
    };

    checkOverflow();
    window.addEventListener("resize", checkOverflow);
    return () => window.removeEventListener("resize", checkOverflow);
  }, [additional_images]);

  const getImageWidth = () => {
    if (carouselRef.current) {
      const image = carouselRef.current.querySelector(".carousel-image img");
      if (image) {
        return image.offsetWidth;
      }
    }
    return 250;
  };

  const scrollLeft = () => {
    if (carouselRef.current) {
      const imageWidth = getImageWidth();
      carouselRef.current.scrollBy({
        left: -imageWidth,
        behavior: "smooth",
      });
    }
  };

  const scrollRight = () => {
    if (carouselRef.current) {
      const imageWidth = getImageWidth();
      carouselRef.current.scrollBy({
        left: imageWidth,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      {additional_images?.length > 0 && (
        <div className="image-carousel-wrapper">
          {hasOverflow && (
            <button className="scroll-button left" onClick={scrollLeft}>
              &#10094;
            </button>
          )}
          <div className="image-carousel" ref={carouselRef}>
            {additional_images.map((image, index) => (
              <div className="carousel-image" key={image.id}>
                <Image
                  src={image.attributes.url}
                  width={200}
                  height={200}
                  alt={image.alternativeText || `Image ${index + 1}`}
                />
              </div>
            ))}
          </div>
          {hasOverflow && (
            <button className="scroll-button right" onClick={scrollRight}>
              &#10095;
            </button>
          )}
        </div>
      )}
    </>
  );
};

export default ImageCarousel;
